import { Field_Keys } from '../../../../../constants';
import useFetchData from '../../../../../hooks/fetchHook';
import { maskEntry } from '../../../../../utils/utils';
import { knowledgeBaseKeys } from '../controllers/variables';

export const useGetProductCategories = () => {
  const [
    {
      data: { categories = [], category_count: categoryCount = 0 } = {},
      isLoading,
      isError,
    },
  ] = useFetchData('categories', {});

  return {
    data: {
      categories: formatter(categories, mask),
      categoryCount,
    },
    isLoading,
    isError,
  };
};

export const formatter = data => {
  maskEntry(data, mask);
  return data;
};

const mask = {
  [Field_Keys.CATEGORY.SUBCATEGORY_ID]: knowledgeBaseKeys.categoryId,
  [Field_Keys.CATEGORY.FULL]: knowledgeBaseKeys.productCategory,
};
